export default {"src":"/_next/static/media/illustration-paw-clean.a5dbc554.svg","height":60,"width":59};